<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>

<script>
// import serialport from 'serialport'

// import fs from 'fs'

export default {
  name: 'App',
  data () {
    return {
    }
  },
methods:{

},
watch:{

},

mounted(){
  // if(localStorage.getItem("total_token").length>6){
  //   this.$axios.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem("total_token")
  // }
}

}
</script>

<style>
body {
  margin: 0;
}

.formBox .el-form{
    margin:8px 10px;
  }
.formBox .el-form-item{
    margin:8px 8px!important;
  }
  .el-table .el-table__cell{
    text-align:center !important;
  }
</style>
